import { render, staticRenderFns } from "./StatisticsLineItem.vue?vue&type=template&id=f5392742&scoped=true&"
import script from "./StatisticsLineItem.vue?vue&type=script&lang=js&"
export * from "./StatisticsLineItem.vue?vue&type=script&lang=js&"
import style0 from "./StatisticsLineItem.vue?vue&type=style&index=0&id=f5392742&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5392742",
  null
  
)

export default component.exports